import * as actionTypes from '../actionTypes';

const state = {
  isLoadingGetAttendeeCheckinSituation: false,
  getAttendeeCheckinSituationMessage: '',
  getAttendeeCheckinSituationFailed: '',

  isLoadingPostExportStatisticCheckinReport: false,
  postExportStatisticCheckinReportMessage: '',
  postExportStatisticCheckinReportFailed: '',

  isLoadingGetCustomizeChartList: false,
  getCustomizeChartListMessage: '',
  getCustomizeChartListFailed: '',

  isLoadingPostSingleCustomizeChart: false,
  postSingleCustomizeChartMessage: '',
  postSingleCustomizeChartFailed: '',

  isLoadingDeleteSingleCustomizeChart: false,
  deleteSingleCustomizeChartMessage: '',
  deleteSingleCustomizeChartFailed: '',
};

const initialState = JSON.parse(JSON.stringify(state));

function statisticReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initialState,
      };
    case actionTypes.GET_ATTENDEE_CHECKIN_SITUATION_PENDING:
      return {
        ...globalState,
        isLoadingGetAttendeeCheckinSituation: true,
      };
    case actionTypes.GET_ATTENDEE_CHECKIN_SITUATION_FULFILLED:
      return {
        ...globalState,
        isLoadingGetAttendeeCheckinSituation: false,
        getAttendeeCheckinSituationMessage: action.data,
        getAttendeeCheckinSituationFailed: '',
      };
    case actionTypes.GET_ATTENDEE_CHECKIN_SITUATION_FAILURE:
      return {
        ...globalState,
        isLoadingGetAttendeeCheckinSituation: false,
        getAttendeeCheckinSituationMessage: '',
        getAttendeeCheckinSituationFailed: action.error,
      };
    case actionTypes.POST_EXPORT_STATISTIC_CHECKIN_REPORT_PENDING:
      return {
        ...globalState,
        isLoadingPostExportStatisticCheckinReport: true,
      };
    case actionTypes.POST_EXPORT_STATISTIC_CHECKIN_REPORT_FULFILLED:
      return {
        ...globalState,
        isLoadingPostExportStatisticCheckinReport: false,
        postExportStatisticCheckinReportMessage: action.data,
        postExportStatisticCheckinReportFailed: '',
      };
    case actionTypes.POST_EXPORT_STATISTIC_CHECKIN_REPORT_FAILURE:
      return {
        ...globalState,
        isLoadingPostExportStatisticCheckinReport: false,
        postExportStatisticCheckinReportMessage: '',
        postExportStatisticCheckinReportFailed: action.error,
      };
    case actionTypes.GET_CUSTOMIZE_CHART_LIST_PENDING:
      return {
        ...globalState,
        isLoadingGetCustomizeChartList: true,
      };
    case actionTypes.GET_CUSTOMIZE_CHART_LIST_FULFILLED:
      return {
        ...globalState,
        isLoadingGetCustomizeChartList: false,
        getCustomizeChartListMessage: action.data,
        getCustomizeChartListFailed: '',
      };
    case actionTypes.GET_CUSTOMIZE_CHART_LIST_FAILURE:
      return {
        ...globalState,
        isLoadingGetCustomizeChartList: false,
        getCustomizeChartListMessage: '',
        getCustomizeChartListFailed: action.error,
      };
    case actionTypes.POST_SINGLE_CUSTOMIZE_CHART_PENDING:
      return {
        ...globalState,
        isLoadingPostSingleCustomizeChart: true,
      };
    case actionTypes.POST_SINGLE_CUSTOMIZE_CHART_FULFILLED:
      return {
        ...globalState,
        isLoadingPostSingleCustomizeChart: false,
        postSingleCustomizeChartMessage: action.data,
        postSingleCustomizeChartFailed: '',
      };
    case actionTypes.POST_SINGLE_CUSTOMIZE_CHART_FAILURE:
      return {
        ...globalState,
        isLoadingPostSingleCustomizeChart: false,
        postSingleCustomizeChartMessage: '',
        postSingleCustomizeChartFailed: action.error,
      };
    case actionTypes.DELETE_SINGLE_CUSTOMIZE_CHART_PENDING:
      return {
        ...globalState,
        isLoadingDeleteSingleCustomizeChart: true,
      };
    case actionTypes.DELETE_SINGLE_CUSTOMIZE_CHART_FULFILLED:
      return {
        ...globalState,
        isLoadingDeleteSingleCustomizeChart: false,
        deleteSingleCustomizeChartMessage: action.data,
        deleteSingleCustomizeChartFailed: '',
      };
    case actionTypes.DELETE_SINGLE_CUSTOMIZE_CHART_FAILURE:
      return {
        ...globalState,
        isLoadingDeleteSingleCustomizeChart: false,
        deleteSingleCustomizeChartMessage: '',
        deleteSingleCustomizeChartFailed: action.error,
      };
    default:
      return globalState;
  }
}

export { statisticReducer as default };
